import Mixin from "../../mixin.js";
import Funnel from "../../services/funnel-service.js";
import Utils from "../../services/utils-service.js";
import tooltip from "./tooltip.js"
import { Carousel, Slide } from 'vue-carousel';

const template = `
	<div  v-if="fs.isMobile() ">
		<carousel  :per-page="1" v-if="showMyComponent" @reset="resetMyComponent" @pageChange="computeAdtHeight()" @pagination-click="navigationClick($event, $event)">
			<slide   v-for="(quote, index) in allQuotes" :key="index">
				<div class="quote-select card"  :class="quoteType(quote)" :uid="quote.uid" :id="'carousel_'+quote.uid" v-if="!quote.qc_type || quote.qc_type == 1">
					<img class="center carrier-logo" :src="icon(quote.data)" :alt="quote.data.carrier_name"/>
					<p v-if="checkIfBundle(input.uid)" class="lob">{{ input.data.lob_text }}</p>

					<p class="quote" v-html="computedMonthly(quote)"></p>
					<p class="total-premium" v-html="computedTotal(quote)"></p>

					<p class="discount" v-if="quote.data.groupDiscount">
						<img alt="" class="iconic iconic-sm" data-src="/static/images/iconic/star.svg"> {{ quote.data.groupDiscount }} <img alt="" class="iconic iconic-sm" data-src="/static/images/iconic/star.svg">
					</p>
					<button tabindex="0" role="button" :aria-expanded="accordionIsOpen ? 'true' : 'false'" :aria-label="'Show coverages - '+input.data.carrier_name" class="lob-label" @click.prevent="toggleAccordion()" v-html="showCoverageText"></button>
					<button v-if="accordionIsOpen && checkIfBundle(input.uid)" v-for="feature in input.features" class="lob-label " :class="quoteType.length > 1 ? ' table-title ': ''"   v-html="">{{feature.label}}</button>
					<div class="grid collapse">
						<div class="accordion clm" v-for="feature in quote.features" :class="feature.class">
							<ul class=" table coverage-table accordion-item" :class="{open: accordionIsOpen}">
								<li class="tr" v-for="item in feature.items" v-if="accordionIsOpen" >
									<div class="td td6 text-right" ><span>{{ item.label }}</span></div>
									<div class="td td6 text-left"  >
										<span >
											{{ item.value }}
											<b-tooltip :element='item' v-show="item.helpText"/>
										</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="grid collapse">
						<div class="s8 m6 clm center" >
							<button v-if="quote.quote_type != 2" class="button medium action fill primary-btn next-step" :aria-label="input.button_text+' - '+input.data.carrier_name" @click.prevent="exec($event, quote, {skipUpdate:true})">
								{{quote.button_text}}
								<img alt="" class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
							</button>
						</div>
					</div>
				</div>
				<div class="quote-select card carousel-type-2" :id="'carousel_'+quote.uid" :uid="quote.uid" v-if="quote.qc_type == 2" :style="adtStyles">
					<p class="quote" v-html="computedAdtLabel(quote)"></p>
					<h4 class="total-premium" v-html="computedAdtValue(quote)"></h4>
					<div class="grid collapse btn-container">
						<div class="s8 clm center">
							<button v-if="quote.quote_type != 2" class="button medium action fill primary-btn next-step" @click.prevent="exec($event, quote, {skipUpdate:true})">
								{{quote.button_text}}
								<img alt="" class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
							</button>
						</div>
					</div>
				</div>
			</slide>
		</carousel>
	</div>
	
`

export default {
	name: 'b-quote-carousel',
	template,
	props: ['iuid'],
	data() {
		return {
			"accordionIsOpen": false,
			"showMyComponent": true,
			"adtStyles": {
				minHeight: null,
				height: '100%'
			}
		}
	},
	mixins: [Mixin],
	components: {
		Carousel,
		Slide,
		'b-tooltip': tooltip
	},
	watch: {
		'window.width': function (newVal, oldVal) {
			if (newVal != oldVal) {
				this.resetMyComponent()
			}
		},
		'window.heigth': function (newVal, oldVal) {
			if (newVal != oldVal) {
				this.resetMyComponent()
			}
		},

	},
	computed: {
		...Vuex.mapGetters([
			'funnel',
			'active_page',
			'window'
		]),
		showCoverageText: function () {
			return this.accordionIsOpen ? 'Hide Coverages' : 'Show Coverages';
		},
		fs: function () {
			return new Funnel({ ctx: this.$store, router: this.$router });
		},
		input: function () {
			return this.$store.getters.funnel.elements[this.iuid];
		},
		items: function () {
			return { ... this.input.options };
		},
		allQuotes: function () {
			var self = this;
			var quotes = this.funnel.idsMap.pages[this.active_page].sections.sc_rtq.inputs_sequence.filter(function (i) {
				if (self.funnel.elements[i].type == "quote-card") {

					return i
				}
			})
			var quoteObj = {}

			quotes.map(function (qid) {
				quoteObj[qid] = self.funnel.elements[qid]
			})
			return quoteObj
		}
	},
	updated: function () {
		IconicJS().inject('.icon, .iconic')
	},
	mounted: function () {
		var self = this;
		setTimeout(function () {
			self.computeAdtHeight()
		}, 1000)


		const wrapper = document.getElementById('form-pg_rtq');

		wrapper.addEventListener('click', function (event) {
			const isButton = event.target.nodeName === 'BUTTON';
			if (!isButton) {
				return;
			}
			console.log(event, 'mountedClick');
			event.preventDefault()
		})
	},
	methods: {
		navigationClick: function (e, r) {
			console.log(e, r);
			if (Number.isFinite(e)) {
				console.log(e, 'navigation slide click');

			} else {
				console.log(e);
			}
		},
		quoteType: function (q) {
			if (q.qexec) {
				var self = this;
				var qt = []
				Object.keys(q.qexec).map(function (key) {
					qt.push(key)
				})
				return qt
			}
		},
		checkIfBundle: function (iuid) {
			if (iuid.indexOf("in_rtq") >= 0 && iuid.indexOf("|") >= 0) {
				console.log("it's a bundle " + iuid);
				console.log(this.input.class);
				return true
			}
		},
		computedAdtLabel: function (quote) {
			//we need the real number calculated from the total of non shown quotes
			return quote.label
		},
		computedAdtValue: function (quote) {
			return quote.value
		},
		resetMyComponent: function () {
			//had to add a reset component function because we were losing functionality on resize -G
			// this.showMyComponent = false;
			// var self = this;
			// this.$nextTick(function(){
			//     self.showMyComponent = true;
			// 	IconicJS().inject('.icon, .iconic')
			// });
		},
		computedMonthly: function (quote) {
			if (quote.data) {
				if (quote.data.monthly) {
					return "$" + quote.data.monthly + "<small>/month</small>"
				}
			}
		},
		computedTotal: function (quote) {
			if (quote.data) {
				if (quote.data.onePayPossiblePIF) {
					return "$" + quote.data.onePayPossiblePIF + " Total Premium "
				}
			}
		},
		toggleAccordion: function () {
			this.accordionIsOpen = !this.accordionIsOpen

		},
		icon: function (item) {
			let iconName;
			if (!this.fs.isMobile()) {
				return
			}
			if (item.icon_name) {
				iconName = item.icon_name
			} else {
				let text = this.input.label
				iconName = text.toLowerCase().split(" ").join("-").replace(/[^a-zA-Z ]/g, "");
			}
			const pathToIcon = '/static/images/carriers/'
			const iconFormat = '.svg'
			return pathToIcon + iconName + "-color" + iconFormat;
		},
		computeAdtHeight: function () {
			var self = this
			var qcHeight;
			var PqcHeight;

			Object.keys(self.allQuotes).map(function (quid, qi) {
				var pqi = qi - 1;
				var pQUid = Object.keys(self.allQuotes)[pqi];
				if (!Utils.isEmpty(quid) && !Utils.isObjEmpty(document.getElementById('carousel_' + quid))) {
					qcHeight = document.getElementById('carousel_' + quid).offsetHeight;
				}
				if (!Utils.isEmpty(pQUid) && !Utils.isObjEmpty(document.getElementById('carousel_' + pQUid))) {
					PqcHeight = document.getElementById('carousel_' + pQUid).offsetHeight;
				}
			});
			if (!Utils.isEmpty(PqcHeight)) {
				this.adtStyles.minHeight = PqcHeight + 'px';
			}

		},
		tableTitle: function (qt) {
			if (qt == 'auto') {
				return 'Auto Coverages'
			}
			if (qt == 'home') {
				return 'Home Coverages'
			}
			if (qt == 'rent') {
				return 'Coverages'
			}

		}
	}
};